import React, { useState, useCallback } from 'react';
import { DatePicker } from '@Sage/hoi-poi-ui';
import { DATEFNS_LOCALES } from '@Sage/ssm-utils';
import { connect } from 'react-redux';

import { default as dateFormat } from 'date-fns/format';
import { default as isDateFn } from 'date-fns/isDate';

export const LOCALE_DATES = DATEFNS_LOCALES;

export function formatDate(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!isDateFn(d)) d = new Date(date);
    return dateFormat(d, format, {
        locale: DATEFNS_LOCALES[locale],
    });
}

function mapStateToProps({ authentication }) {
    return {
        user: authentication.user,
    };
}

function CrudDates({ user, className, input, ...props }) {
    const [finalValue, setValue] = useState(input.value);

    const format = useCallback(
        (value) => {
            return formatDate(value, user.locale, 'P');
        },
        [user.locale],
    );

    const onChange = (value) => {
        setValue(value || null);
        input.onChange && input.onChange(value || null);
    };

    return (
        <div className="input-datepicker">
            <DatePicker
                lang={user.lang}
                value={finalValue}
                formatDate={format}
                onChange={onChange}
                isFullWidth
                {...props}
            />
        </div>
    );
}

export default connect(mapStateToProps)(CrudDates);
